import * as React from 'react';

const UserOwner: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14 5.58984C14 2.91016 11.8398 0.75 9.16016 0.75C6.50781 0.777344 4.375 2.91016 4.375 5.5625C4.375 6.10938 4.45703 6.60156 4.59375 7.09375L0.191406 11.4961C0.0546875 11.6328 0 11.7969 0 11.9609V14.0938C0 14.4766 0.273438 14.75 0.65625 14.75H3.71875C4.07422 14.75 4.375 14.4766 4.375 14.0938V13H5.46875C5.82422 13 6.125 12.7266 6.125 12.3438V11.25H7.13672C7.32812 11.25 7.49219 11.168 7.62891 11.0312L8.28516 10.293C8.55859 10.3477 8.85938 10.375 9.1875 10.375C11.8398 10.375 14 8.24219 14 5.58984ZM9.1875 4.25C9.1875 3.53906 9.76172 2.9375 10.5 2.9375C11.2109 2.9375 11.8125 3.53906 11.8125 4.25C11.8125 4.98828 11.2109 5.5625 10.5 5.5625C9.76172 5.5625 9.1875 4.98828 9.1875 4.25Z'
      fill='#727272'
    />
  </svg>
);

export default UserOwner;
